import {
  clearCloseModalOnWindow,
  isTvEnv,
  setCloseModalOnWindow,
  setIsModalOnWindow,
} from "./common.helpers";

// TV-specific workaround 🤫
// A more permanent solution would involve implementing proper back button handling within the TV app.
// However, that would require a new app release, which could take up to 2 months for approval and release by the Samsung and LG teams.
export const tvBackButtonOverrideHandler = {
  set: function (
    callback: () => void,
    autoClearOnCallback = true,
    key?: string,
  ) {
    if (isTvEnv()) {
      setIsModalOnWindow(true, key);
      setCloseModalOnWindow(() => {
        callback();
        if (autoClearOnCallback) {
          this.clear();
        }
      });
    }
  },
  clear: function (key?: string) {
    if (isTvEnv()) {
      setIsModalOnWindow(false, key);
      clearCloseModalOnWindow(key);
    }
  },
};
